export const loadZohoBot = () => {
  const openZohoChat = () => {
    if (
      (window as any).ZohoDeskAsap &&
      typeof (window as any).ZohoDeskAsap.Action === "function"
    ) {
      (window as any).ZohoDeskAsap.Action("Open");
      console.log("Zoho bot chat window opened via API.");
    } else {
      // If ZohoDeskAsap is not ready, retry after a short delay.
      // This is a fallback for timing issues.
      setTimeout(openZohoChat, 300);
    }
  };

  const zohoBotContainer = document.getElementById("zohohc-asap-web-app-main");
  if (zohoBotContainer) {
    zohoBotContainer.style.display = "block";
    openZohoChat();
    return;
  }

  if (!document.getElementById("zohodeskasapscript")) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zohodeskasapscript";
    script.defer = true;
    script.nonce = "{place_your_nonce_value_here}"; // Replace with actual nonce if needed
    script.src =
      "https://desk.zoho.in/portal/api/web/asapApp/216050000000850592?orgId=60045400507";

    const firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }

    // Set up the ZohoDeskAsapReady callback handler
    (window as any).ZohoDeskAsapReady = function (cb: any) {
      const e = ((window as any).ZohoDeskAsap__asyncalls =
        (window as any).ZohoDeskAsap__asyncalls || []);
      if ((window as any).ZohoDeskAsapReadyStatus) {
        cb && e.push(cb);
        e.forEach((f: any) => f && f());
        (window as any).ZohoDeskAsap__asyncalls = null;
      } else {
        cb && e.push(cb);
      }
    };

    // Now, register our callback to open the chat
    (window as any).ZohoDeskAsapReady(openZohoChat);
  }
};

export const unloadZohoBot = () => {
  // Hide Zoho bot UI elements, but don't destroy them
  const zohoBotContainer = document.getElementById("zohohc-asap-web-app-main");
  if (zohoBotContainer) {
    zohoBotContainer.style.display = "none";
    console.log("Zoho bot UI elements have been hidden.");
  }

  // Also, if the chat window is open, we should close it.
  // Check if ZohoDeskAsap and its methods are available
  if (
    (window as any).ZohoDeskAsap &&
    typeof (window as any).ZohoDeskAsap.Action === "function"
  ) {
    (window as any).ZohoDeskAsap.Action("Close");
    console.log("Zoho bot chat window closed via API.");
  }
};
